import {
    formatPermissions,
    can as helpCan,
} from '../../../services/auth/permissions'

/**
 * @description
 * Check if user is authenticated with state data (from local storage)
 *
 * @param {@object} state with state data of auth module
 * @return {boolean} true is authenticated, false otherwise
 */
const isAuthenticated = state => !!state.token

const can = state => helpCan(formatPermissions(state.permissions))
const fullName = e => `${e.names} ${e.last_name1}`
const userName = state => (state.user ? fullName(state.user.hr_employee) : null)
const branchOfficeId = state =>
    state.user && state.user.hr_employee
        ? state.user.hr_employee.g_branch_office_id
        : null
/**
 * @description
 * Get status of user (success, error or loading)
 *
 * @param {object} state with state data of auth module
 * @return {string}
 */
const authStatus = state => state.status

export default {
    isAuthenticated,
    authStatus,
    can,
    userName,
    branchOfficeId,
}
